function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Logger from '../../../../../wdh-foundation/wdh-logger/wdh-logger';
import UrlUtils from '../utilities/url-utils';
import SiteLinkManager from '../infrastructure/site-link-manager';
import { SiteLinks, Ids, QueryStrings } from '../infrastructure/const';
var ShopInitializationUtils = /*#__PURE__*/function () {
  function ShopInitializationUtils() {
    _classCallCheck(this, ShopInitializationUtils);
  }
  return _createClass(ShopInitializationUtils, null, [{
    key: "getMockValue",
    value:
    /**
    * Get the mock from url paramters, to get mock values from the client library
    *
    * @private
    */
    function getMockValue() {
      var mockParameter = UrlUtils.getParameterByName('mock');
      var mock = false;
      if (mockParameter === 'true') {
        mock = false;
      }
      if (localStorage && localStorage.getItem('mock') === 'true') {
        mock = true;
      }
      Logger.info("Mock: ".concat(mock));
      return mock;
    }
  }, {
    key: "getBulkLink",
    value: function getBulkLink(categoryId, familyId) {
      return "".concat(SiteLinkManager.getSiteLink(SiteLinks.PRODUCTLIST), "?categoryId=").concat(categoryId, "&familyId=").concat(familyId);
    }
  }, {
    key: "getClientOrderLink",
    value: function getClientOrderLink(categoryId) {
      return "".concat(SiteLinkManager.getSiteLink(SiteLinks.CLIENTORDERSTEP1), "?categoryId=").concat(categoryId);
    }

    /**
    * Builds an event for injecting menu items in to the new menu using the eventbus
    *
    * @param {Array} menuItems  The menuItems that needs to be injected into the menu
    * @private
    */
  }, {
    key: "buildMenuItemsEventBusMessage",
    value: function buildMenuItemsEventBusMessage(menuItems, isBulkOrder) {
      var _this = this;
      var newMenuItems = [];
      menuItems.forEach(function (menuItem) {
        var url = "".concat(SiteLinkManager.getSiteLink(SiteLinks.CLIENTORDERSTEP1), "?categoryId=").concat(menuItem.id);
        var newMenuItem = {
          title: menuItem.title,
          url: url
        };
        if (menuItem.children !== undefined) {
          newMenuItem.menuItems = [];
          menuItem.children.forEach(function (childMenuItem) {
            var childUrl;
            if (isBulkOrder) {
              childUrl = childMenuItem.id === undefined ? '' : _this.getBulkLink(menuItem.id, childMenuItem.id);
            } else {
              childUrl = childMenuItem.id === undefined ? '' : _this.getClientOrderLink(menuItem.id);
            }
            if (childMenuItem.id === Ids.DEFAULT_ID) {
              childUrl = _this.getUrlToCategory(menuItem.id);
            }
            newMenuItem.menuItems.push({
              title: childMenuItem.title,
              url: childUrl
            });
          });
        }
        newMenuItems.push(newMenuItem);
      });
      return newMenuItems;
    }
  }, {
    key: "getUrlToCategory",
    value: function getUrlToCategory(categoryId) {
      var prefix = SiteLinkManager.getSiteLink(SiteLinks.PRODUCTLIST);
      var args = {};
      args[QueryStrings.CATEGORY_ID] = categoryId;
      var url = UrlUtils.createLink(prefix, args);
      return url;
    }
  }]);
}();
export default ShopInitializationUtils;